// React
import React, { useState, useCallback } from 'react';
import { Card, CardHeader, CardBody, Col, Row } from 'reactstrap';

// DataTable
import DataTable from 'react-data-table-component';
import DataTableExtensions from 'react-data-table-component-extensions';

// Scss
// import 'react-data-table-component-extensions/dist/index.css'; => default style of search by dist.
import '../../assets/scss/pages/_datatable-search.scss';

// Components
import { ModalDelete } from '../../components/modalDelete';

export const CardList = ({
  data,
  title,
  props,
  isCard,
  actions,
  columns,
  children,
  handleEdit,
  titleButton,
  handleButton,
  handleSearch,
  handleDelete,
  keySearch = 'name',
  isSearchRemote = false,
  ...rest
}) => {
  const [isHover, setIsHover] = useState(0);
  const [registerId, setRegisterId] = useState(null);
  const [modal_delete, setModal_delete] = useState(false);

  const toggleModal = useCallback(
    (id) => {
      setRegisterId(id);
      setModal_delete(!modal_delete);
    },
    [modal_delete]
  );

  const createColumnsWithActionsData = useCallback(
    (cellProps) => {
      let columns = (actions || []).map((item) => {
        return (
          <li
            key={item.id}
            title={item.label}
            onClick={() => {
              item.onPress(cellProps);
            }}
          >
            <i
              className={`${item.icon} fs-20 text-${item.classNameColorIcon}`}
            ></i>
          </li>
        );
      });

      return columns;
    },
    [actions, toggleModal]
  );

  return (
    // when using remote search, always remember to pass filter={false} (as a property) for the component.
    <div>
      {!isCard ? (
        <Card id="customerList">
          {children}

          {isSearchRemote && (
            <CardBody className="border-bottom-dashed border-bottom">
              <form
                onSubmit={(e) => {
                  e.preventDefault();
                }}
              >
                <Row className="g-3">
                  <Col xl={2}>
                    <div className="search-box">
                      <input
                        type="text"
                        className="form-control search /"
                        placeholder="Pesquisar..."
                        onChange={(e) => handleSearch(e)}
                      />
                      <i className="ri-search-line search-icon"></i>
                    </div>
                  </Col>
                </Row>
              </form>
            </CardBody>
          )}

          <div className="card-body">
            <div className="table-responsive table-card mb-1">
              <DataTableExtensions
                {...rest}
                columns={[
                  ...columns,
                  {
                    name: <span className="font-weight-bold fs-13"> </span>,
                    sortable: false,
                    style: {
                      justifyContent: 'end',
                    },
                    cell: (cellProps) => {
                      return (
                        <ul
                          className="list-inline hstack gap-2 mb-0"
                          style={{
                            display: isHover === cellProps.id ? 'flex' : 'none',
                            cursor: 'pointer',
                          }}
                        >
                          {createColumnsWithActionsData(cellProps)}
                          {handleDelete && (
                            <li
                              title="Remover"
                              onClick={() => toggleModal(cellProps)}
                            >
                              <i className="las la-trash-alt fs-20 text-danger"></i>
                            </li>
                          )}
                        </ul>
                      );
                    },
                  },
                ]}
                data={data}
                print={false}
                export={false}
                filterPlaceholder="Pesquisar..."
              >
                <DataTable
                  {...rest}
                  onRowMouseEnter={(row) => {
                    setIsHover(row.id);
                  }}
                  onRowMouseLeave={() => {
                    setIsHover(0);
                  }}
                  paginationComponentOptions={{
                    rowsPerPageText: 'Linhas por página:',
                    rangeSeparatorText: 'de',
                    selectAllRowsItem: true,
                    selectAllRowsItemText: 'Todos',
                  }}
                />
              </DataTableExtensions>

              <ModalDelete
                isOpen={modal_delete}
                handleDelete={() => {
                  handleDelete(registerId);
                  setModal_delete(!modal_delete);
                }}
                goBack={() => setModal_delete(!modal_delete)}
              />
            </div>
          </div>
        </Card>
      ) : (
        <>
          <CardHeader className="border-bottom-dashed">
            <Row className="g-4 align-items-center">
              <div className="col-sm">
                <div>
                  <h5 className="card-title mb-0">{title}</h5>
                </div>
              </div>
              <div className="col-sm-auto">
                <div>
                  <button
                    type="button"
                    className="btn btn-success add-btn"
                    id="create-btn"
                    onClick={() => {
                      handleButton();
                    }}
                  >
                    <i className="ri-add-line align-bottom me-1"></i>
                    {titleButton}
                  </button>{' '}
                </div>
              </div>
            </Row>
          </CardHeader>

          {children}

          {isSearchRemote && (
            <CardBody className="border-bottom-dashed border-bottom">
              <form
                onSubmit={(e) => {
                  e.preventDefault();
                }}
              >
                <Row className="g-3">
                  <Col xl={2}>
                    <div className="search-box">
                      <input
                        type="text"
                        className="form-control search /"
                        placeholder="Pesquisar..."
                        onChange={(e) => handleSearch(e)}
                      />
                      <i className="ri-search-line search-icon"></i>
                    </div>
                  </Col>
                </Row>
              </form>
            </CardBody>
          )}

          <div className="card-body">
            <div className="table-responsive table-card mb-1">
              <DataTableExtensions
                {...rest}
                columns={[
                  ...columns,
                  {
                    name: <span className="font-weight-bold fs-13"> </span>,
                    sortable: false,
                    style: {
                      justifyContent: 'end',
                    },
                    cell: (cellProps) => {
                      return (
                        <ul
                          className="list-inline hstack gap-2 mb-0 "
                          style={{
                            display: isHover === cellProps.id ? 'flex' : 'none',
                            cursor: 'pointer',
                          }}
                        >
                          {createColumnsWithActionsData(cellProps)}
                          {handleDelete && (
                            <li
                              title="Remover"
                              onClick={() => toggleModal(cellProps)}
                            >
                              <i className="las la-trash-alt fs-20 text-danger"></i>
                            </li>
                          )}
                        </ul>
                      );
                    },
                  },
                ]}
                data={data}
                print={false}
                export={false}
                filterPlaceholder="Pesquisar..."
              >
                <DataTable
                  {...rest}
                  onRowMouseEnter={(row) => {
                    setIsHover(row.id);
                  }}
                  onRowMouseLeave={() => {
                    setIsHover(0);
                  }}
                  paginationComponentOptions={{
                    rowsPerPageText: 'Linhas por página:',
                    rangeSeparatorText: 'de',
                    selectAllRowsItem: true,
                    selectAllRowsItemText: 'Todos',
                  }}
                />
              </DataTableExtensions>

              <ModalDelete
                isOpen={modal_delete}
                handleDelete={() => {
                  handleDelete(registerId);
                  setModal_delete(!modal_delete);
                }}
                goBack={() => setModal_delete(!modal_delete)}
              />
            </div>
          </div>
        </>
      )}
    </div>
  );
};
